



// Vue
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

// Constants
import Assets from '@/constants/assets.ts';

// Components
import Btn, { BtnColor, BtnWidth, BtnHeight, BtnFontSize, BtnPredefinedStyle } from '@/shared/components/btn.component.vue';
import SpotlightText, { SpotlightTextColor } from '@/shared/components/SpotlightText.component.vue';
import Input, { InputStyle } from '@/shared/components/input.component.vue';

// Views
import InfoView from '@/shared/views/info.view.vue';
import NifValidation from '@/client/budget/views/mandate-signature/nif-validation/index.vue';
import MandateActions from '@/client/budget/views/mandate-signature/mandate-actions/index.vue';
import SignModal from '@/client/budget/views/mandate-signature/mandate-actions/sign-modal/index.vue';

// Services
import BudgetService from '@/manager/budget/budget.service';


@Component({
    components: {
        Btn,
        SpotlightText,
        Input,
        InfoView,
        NifValidation,
        MandateActions,
        SignModal,
    },
})
export default class MandateSignature extends Vue {
    @Prop() private id!: string;


    private assets = Assets;
    private btnColor = BtnColor;
    private btnPredefinedStyle = BtnPredefinedStyle;
    private btnFontSize = BtnFontSize;
    private btnWidth = BtnWidth;
    private btnHeight = BtnHeight;
    private setCurrentBudgetMandate !: any;
    private currentBudget !: any;
    private nifValidated = false;
    private existingSign = false;
    private showSignModal = false;
    private signFinished = false;
    private signError = false;
    private requestFinished = false;
    private infoLiterals =  {
        title: 'Ups!',
        subtitle: 'Parece que el panel de firma solo está disponible en la versión móvil, ' +
            'accede a tu dispositivo para poder continuar con el proceso.',
        signAgainBtn: 'Volver a firmar',
    };


    private created() {
        this.checkMandateSignStatus();
    }


    get backgroundImage() {
        return {
            'background-image': `url("${this.assets.circleBlueGreen}")`,
            'background-repeat': 'no-repeat',
            'background-position-x': 'right',
            'background-position-y': '-95px',
            'background-size': '157px 157px',
        };
    }

    get showNifValidation() {
        return (
            this.requestFinished &&
            !this.nifValidated &&
            !this.showInfoView &&
            !this.existingSign
        );
    }

    get showMandateActions() {
        return (
            this.requestFinished &&
            this.nifValidated &&
            !this.showInfoView &&
            !this.existingSign
        );
    }

    get showInfoView() {
        return (
            this.requestFinished &&
            (
                this.signFinished ||
                this.signError ||
                this.existingSign
            )
        );
    }

    get infoViewLiterals() {
        let literals = {
            title: 'Ups! Ha ocurrido un error',
            subtitle: 'Parece que algo no ha ido bien. Vuelve a intentarlo y si el error persiste, ponte en contacto con nosotros.',
        };
        if ( this.signFinished || this.existingSign ) {
            literals = {
                title: 'Mandato SEPA firmado',
                subtitle: '¡Muchas gracias! En breves recibirás un correo de confirmación.',
            };
        }
        return literals;
    }


    private setShowSignModal(value: boolean) {
        this.showSignModal = value;
    }

    private setNifValidated(value: boolean) {
        this.nifValidated = value;
    }

    private checkMandateSignStatus() {
        BudgetService.checkMandateSignStatus(this.id)
            .then(
                (res) => {
                    this.requestFinished = true;
                    this.existingSign = true;
                },
                (err) => {
                    this.requestFinished = true;
                    this.existingSign = false;
                },
            );
    }

    private requestSignature(signature: string) {
        this.setShowSignModal(false);
        BudgetService.signMandate(this.id, {
            sign: signature,
        }).then(
            (res) => {
                this.signFinished = true;
                this.signError = false;
            },
            (err) => {
                this.signError = true;
            },
        );
    }

}
